// VERSÃO 15.0 SUPREMA - REGISTRO DE PEDIDOS & ARQUIVO DE CONCLUÍDOS
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// --- SISTEMA DE NOTIFICAÇÃO (BALÕES UX) ---
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// --- GUARDAS DE ELITE ---
import MobileGuard from './components/guards/MobileGuard';
import RoleGuard from './components/guards/RoleGuard';

// --- PÁGINAS ABERTAS (ZONA NEUTRA) ---
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ImoveisPublicosView from './pages/ImoveisPublicosView';
import OrderTrackingPublicPage from './pages/OrderTrackingPublicPage';

// --- PÁGINAS OPERACIONAIS (USER + MASTER + ADM) ---
import DashboardPage from './pages/DashboardPage';
import CadastrarImovelPage from './pages/CadastrarImovelPage'; 
import ImoveisAprovacaoPage from './pages/ImoveisAprovacaoPage';
import ImoveisPublicadosPage from './pages/ImoveisPublicadosPage';
import ImovelDetalhesPage from './pages/ImovelDetalhesPage';

// --- 📦 NOVA SEÇÃO: COMANDO DE PEDIDOS (TIM EDITION) ---
import OrderNovoPage from './pages/OrderNovoPage';
import OrderGestaoPage from './pages/OrderGestao/OrderGestaoPage';
import OrderConcluidoPage from './pages/OrderConcluidoPage'; // 🎯 NOVA UNIDADE DE ARQUIVO

// --- 🎯 GESTÃO DE LEADS & INTELIGÊNCIA ---
import LeadNovoPage from './pages/Leads/LeadNovoPage';
import LeadGestaoPage from './pages/Leads/LeadGestaoPage';
import LeadClientePage from './pages/LeadClientePage';

// --- 🛡️ SISTEMA & SEGURANÇA ---
import UserApprovalPage from './pages/UserApprovalPage';
import UserManagementPage from './pages/UserManagementPage';
import SecurityGatePage from './pages/SecurityGatePage';
import TemplateIntegrationPage from './pages/TemplateIntegrationPage';
import ModulesPage from './pages/ModulesPage';

// 🖼️ GESTÃO DE BANNERS
import BannerSolutionPage from './pages/6Bannersolution.jsx';

function App() {
  return (
    <MobileGuard>
      <Router>
        <div className="min-h-screen bg-black">
          <Routes>
            {/* 🚪 PORTAL DE ENTRADA */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/vitrine" element={<ImoveisPublicosView />} />
            <Route path="/rastreio" element={<OrderTrackingPublicPage />} />
            
            {/* 👤 ÁREA OPERACIONAL (Dashboard) */}
            <Route path="/dashboard" element={
              <RoleGuard allowedRoles={['USER', 'MASTER', 'ADM']}>
                <DashboardPage />
              </RoleGuard>
            } />

            {/* 📦 ROTAS DE PEDIDOS (TIM EDITION) */}
            <Route path="/pedidos/triagem" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <OrderNovoPage />
              </RoleGuard>
            } />
            <Route path="/pedidos/gestao" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM', 'USER']}>
                <OrderGestaoPage />
              </RoleGuard>
            } />
            {/* 🏁 NOVO ALVO: ARQUIVO DE CONCLUÍDOS */}
            <Route path="/pedidos/concluidos" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM', 'USER']}>
                <OrderConcluidoPage />
              </RoleGuard>
            } />

            {/* 🖼️ ROTA DE BANNERS */}
            <Route path="/banners/cadastrar" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <BannerSolutionPage />
              </RoleGuard>
            } />

            {/* 🏢 GESTÃO DE ATIVOS */}
            <Route path="/imoveis/cadastrar" element={
              <RoleGuard allowedRoles={['USER', 'MASTER', 'ADM']}>
                <CadastrarImovelPage />
              </RoleGuard>
            } />
            <Route path="/imoveis/aprovacao" element={
              <RoleGuard allowedRoles={['USER', 'MASTER', 'ADM']}>
                <ImoveisAprovacaoPage />
              </RoleGuard>
            } />
            <Route path="/imoveis/publicados" element={
              <RoleGuard allowedRoles={['USER', 'MASTER', 'ADM']}>
                <ImoveisPublicadosPage />
              </RoleGuard>
            } />
            <Route path="/imovel/:id" element={
              <RoleGuard allowedRoles={['USER', 'MASTER', 'ADM']}>
                <ImovelDetalhesPage />
              </RoleGuard>
            } />

            {/* 🎯 GESTÃO DE LEADS */}
            <Route path="/leads/novo" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <LeadNovoPage />
              </RoleGuard>
            } />
            <Route path="/leads/gestao" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM', 'USER']}>
                <LeadGestaoPage />
              </RoleGuard>
            } />
            <Route path="/leads/clientes" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM', 'USER']}>
                <LeadClientePage />
              </RoleGuard>
            } />

            {/* ⚙️ ADMINISTRAÇÃO DO SISTEMA */}
            <Route path="/user/management" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <UserManagementPage />
              </RoleGuard>
            } />
            <Route path="/user/approval" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <UserApprovalPage />
              </RoleGuard>
            } />
            <Route path="/sniper/security" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <SecurityGatePage />
              </RoleGuard>
            } />
            <Route path="/templates/integration" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <TemplateIntegrationPage />
              </RoleGuard>
            } />
            <Route path="/modules" element={
              <RoleGuard allowedRoles={['MASTER', 'ADM']}>
                <ModulesPage />
              </RoleGuard>
            } />

            {/* 🚩 FALLBACK */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>

      <ToastContainer 
        position="top-right"
        autoClose={4000}
        theme="dark"
        transition={Flip}
        toastStyle={{ 
          backgroundColor: '#0a0a0a', 
          border: '1px solid rgba(0, 69, 149, 0.2)',
          borderRadius: '16px',
          fontSize: '11px',
          fontWeight: 'bold',
          textTransform: 'uppercase'
        }}
      />
    </MobileGuard>
  );
}

export default App;